import React from "react";
import ReportTemplate2 from "../reportTemplate2";
import { formatCurrency } from "../../../utils/Utils";

function MaterialRequestSummaryList() {
  const columns: any = [
    {
      title: "Site Name",
      key: "siteName",
      dataIndex: "siteName",
      width: 150,
    },
    // {
    //   title: "Block Name",
    //   key: "blockName",
    //   dataIndex: "blockName",
    //   width: 150,
    // },
    {
      title: "Category",
      key: "categoryName",
      dataIndex: "categoryName",
      width: 150,
    },
    {
      title: "Material",
      key: "materialName",
      dataIndex: "materialName",
      width: 150,
    },
    {
      title: "UOM",
      key: "uomName",
      dataIndex: "uomName",
      width: 150,
    },
    {
      title: "BOQ QTY",
      key: "boqQuantity",
      dataIndex: "boqQuantity",
      width: 100,
      render: (text: any) => {
        const value = Number(text); // Convert text to a number
        if (isNaN(value)) {
          return <span style={{ textAlign: "right" }}>N/A</span>; // Handle invalid number
        }
        return <span style={{ textAlign: "right" }}>{value.toFixed(2)}</span>;
      },
    },
    {
      title: "Requested QTY",
      key: "requestedQty",
      dataIndex: "requestedQty",
      width: 100,
      render: (text: any) => {
        const value = Number(text); // Convert text to a number
        if (isNaN(value)) {
          return <span style={{ textAlign: "right" }}>N/A</span>; // Handle invalid number
        }
        return <span style={{ textAlign: "right" }}>{value.toFixed(2)}</span>;
      },
    },
    {
      title: "% to BOQ QTY",
      key: "issuedQtyPercentage",
      dataIndex: "issuedQtyPercentage",
      width: 100,
      render: (text: string) => {
        const value = Number(text); // Convert text to a number
        if (isNaN(value)) {
          return <span style={{ textAlign: "right" }}>N/A</span>; // Handle invalid number
        }
        return <span style={{ textAlign: "right" }}>{value.toFixed(2)} %</span>;
      },
    },
  ];
  return (
    <ReportTemplate2
      pageTitle="Material Request Summary"
      pageDescription="	Overview of all material requests raised across sites"
      moduleKey={window.location.pathname}
      columns={columns}
      filtersOption={{
        site: true,
        category: true,
        material: true,
      }}
      previousPath="/view-material-management-reports"
    />
  );
}

export default MaterialRequestSummaryList;
